<gs-app-menu-panel [items]="menuItems" />